import "./index.css";
import logo from "../../assets/white.png";

export const Spinner = () => {
  return (
    <div className="loader-container">
      <div className="loader-pulse">
        <div className="loader-dot" />
      </div>
    </div>
  );
};

export const CredentialsLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-logo">
        <img src={logo} alt="MOCCA" style={{ width: 180 }} />
      </div>
      <div className="loader-pulse">
        <div className="loader-dot" />
      </div>
      <p className="loader-text">Cargando credenciales y registro de socios</p>
      <div className="loader-bar">
        <div className="loader-bar-inner" />
      </div>
    </div>
  );
};

export const MiniSpinner = () => {
  return (
    <div className="loader-pulse" style={{ width: 32, height: 32 }}>
      <div className="loader-dot" style={{ width: 8, height: 8 }} />
    </div>
  );
};
